// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__JuyLb","detailsBorder":"styles_detailsBorder__10hfd"};